import { LayersTypes } from '@app/core/shared/enums/field-view-layer.types';
import TileLayer from 'ol/layer/Tile';
import { TileWMS } from 'ol/source';
import { FieldViewBathyBaseMapLayer } from '../models/field-view';

export const gebcoBathyBaseMapLayers: FieldViewBathyBaseMapLayer[] = [
  { year: 2024, layer: 'GEBCO_2024' },
  { year: 2023, layer: 'GEBCO_2023' },
  { year: 2022, layer: 'GEBCO_2022' },
  { year: 2021, layer: 'GEBCO_2021' },
  { year: 2020, layer: 'GEBCO_2020' },
  { year: 2019, layer: 'GEBCO_2019' },
  { year: 2014, layer: 'GEBCO_2014' }
];

const createGebcoBathyBaseMapLayer = (year: number, layerName: string): TileLayer<TileWMS> =>
  new TileLayer({
    source: new TileWMS({
      url: `https://wms.gebco.net/${year}/mapserv?`,
      params: {
        LAYERS: layerName,
        TILED: true,
        FORMAT: 'image/png',
        TRANSPARENT: true
      },
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      attributions: `Shift + Alt + drag to rotate. <br/>Shift + drag to zoom.`,
      attributionsCollapsible: false
    }),
    opacity: 0.6,
    visible: year === gebcoBathyBaseMapLayers[0].year,
    properties: { name: layerName, layerType: LayersTypes.BATHY_MAP_LAYER }
  });

export const gebcoLayers = gebcoBathyBaseMapLayers.map(source =>
  createGebcoBathyBaseMapLayer(source.year, source.layer)
);
